import React from "react";
import Seo from "@/utils/seo";
import Head from "next/head";
import Banner from "@/components/ui/banner";
import Team from "@/components/pages/about-us/team";
import { getJsonLd } from "@/utils/get-jsonld";
export default function AboutUs() {
  const seo = {
    slug: "/about-us",
  };
  return (
    <>
      <Seo seo={seo} />
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(getJsonLd({ slug: "about-us" })),
          }}
        />
      </Head>
      <Banner image="/images/banner1.webp" heading="Our Team of Experts" />
      <Team />
    </>
  );
}
